import { ContentstckSerachProps } from "~/templates/L2ContentPage";
import { SearchWithChipsProps } from "./models";

export const mapDataToSearchWithChipsProps = (
  data: ContentstckSerachProps,
): SearchWithChipsProps => ({
  chips: data?.chips,
  placeholder: data?.searchInputPlaceholder,
  searchButtonText: data?.searchButtonText,
  resultPageLink: data?.searchResultLink?.[0]?.url ?? '',
});